import { Link } from 'react-router';

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-20 sm:px-6">
      <p className="eyebrow">Wrong turn</p>
      <h1 className="text-6xl font-black">Road closed</h1>
      <p className="text-muted">That page doesn&apos;t exist. Let&apos;s get you back on the map.</p>
      <Link to="/" className="btn btn-primary self-start no-underline">
        Back home
      </Link>
    </div>
  );
}
